import React, {useContext} from 'react';
import {CommandPalette} from 'erp-react-components';
import {useHistory} from 'react-router-dom';
import {AuthContext} from './contexts/auth.context';
// import {useHRMSAccess} from './contexts/data.context';
import {useTranslation} from 'react-i18next';
export default function ERPCommandPalette() {
  const {t} = useTranslation();
  const authProvider = useContext(AuthContext);
  const {canView, canAdd, canEdit} = authProvider;
  // const {hasAccess} = useHRMSAccess();
  //called sub_routes because these are inside modules, no other meaning.
  const ESS_SUB_ROUTES = [
    // {
    //   path: '/attendance/timesheet',
    //
    //   show: true,
    //   label: 'ESS Attendance',
    //   keywords: 'ess,attendance',
    // },
    {
      path: '/attendance/timesheet',
      show: canView.ess,
      label: 'ESS Timesheet',
      keywords: 'ess,attendance,timesheet',
    },
    {
      path: '/attendance/shift',
      show: canView.ess,
      label: 'ESS Shift',
      keywords: 'ess,shift',
    },
    {
      path: '/attendance/NCNS',
      show: canView.ess,
      label: 'NCNS',
      keywords: 'ess,ncns',
    },
    {
      path: '/attendance/shift/swap-shift',
      show: canView.ess,
      label: 'ESS Attendance',
      keywords: 'swap shift,swap history',
    },
    {
      path: '/profile',
      show: canView.ess,
      label: 'ESS Profile',
      keywords: 'ess profile,profile',
    },
    {
      path: 'profile/:profileTabLabel',
      show: canView.ess,
      label: 'Ess Profile',
      keywords:
        'ess profile,profile,basic,personal,family,financial,employeetrack',
    },
    {
      path: '/activity',
      show: canView.ess,
      label: 'Ess Activity',
      keywords: 'ess activity,activity',
    },
    {
      path: '/activity/add',
      show: canView.ess,
      label: 'Ess Add Activity',
      keywords: 'add activity',
    },
    {
      path: '/activity/edit/:editActivityId',
      show: canView.ess,
      label: 'Ess Edit Activity',
      keywords: 'edit activity',
    },
    {
      path: '/department',
      show: canView.ess,
      label: 'Ess Department',
      keywords: 'ess department,department',
    },
    {
      path: '/leaves',
      show: canView.ess,
      label: 'Ess Leaves',
      keywords: 'ess leaves,leaves',
    },
    {
      path: '/leaves/:leaveTab',
      show: canView.ess,
      label: 'Ess Leaves Master',
      keywords: 'leave balance,leave calendar',
    },
    {
      path: '/leaves/:leaveTab/apply',
      show: canView.ess,
      label: 'Ess Leaves Apply For Leave',
      keywords: 'apply leave,apply',
    },
    {
      path: '/leaves/:leaveTab/edit/:editLeaveId',
      show: canView.ess,
      label: 'Ess Leaves Apply For Leave Edit',
      keywords: 'apply leave,apply,edit leave',
    },
    {
      path: '/holidays',
      show: canView.ess,
      label: 'Ess Holiday',
      keywords: 'ess holiday,holiday',
    },
    {
      path: '/groups',
      show: canView.ess,
      label: 'Ess Groups',
      keywords: 'ess groups,groups',
    },
    {
      path: '/interviews-trainings',
      show: canView.ess,
      label: 'Ess Interviewa Trainings',
      keywords: 'ess interviews,ess trainings,upcomming events,feedback',
    },
    {
      path: '/interviews-trainings/upcoming-events',
      show: canView.ess,
      label: 'Ess Interviews Trainings Master',
      keywords: 'ess interviews,trainings,upcoming-events',
    },
    {
      path: '/interviews-trainings/feedback',
      show: canView.ess,
      label: 'Ess Interviews Trainings Master',
      keywords: 'ess interviews,interview feedback,feedback',
    },
    {
      path: '/interviews-trainings/feedback/:scheduledId',
      show: canView.ess,
      label: 'Ess Interviews Trainings',
      keywords: 'ess interviews,ess trainings,upcomming events,feedback',
    },
    {
      show: true,
      path: '/interview-feedback/:round_id',
      label: 'Interview Feedback',
      keywords: 'feedback,',
    },
    // {
    //   path: '/interviews-trainings/email-creation-form',
    //
    //   show: true,
    //   label: 'Create Employee Email',
    //   keywords: 'IT email',
    // },
    {
      path: '/DepartmentDetails/:departmentId',
      show: canView.ess,
      label: 'Ess Department Details',
      keywords: 'ess department',
    },
  ];
  const ESSList = ESS_SUB_ROUTES.filter((r) => {
    const isColonExists = (r.path || '').includes(':');
    return r.show && !isColonExists;
  }).map((eachRoute) => {
    const ESSPath = '/ess' + eachRoute.path;
    return {
      ...eachRoute,
      path: ESSPath,
      url: ESSPath,
      label: eachRoute.label,
      keywords: eachRoute.keywords,
      onClick: () => onSelect(ESSPath),
    };
  });
  const AMS_SUB_ROUTES = [
    {
      path: '/employee-activity/:attendanceMasterTabId',
      show: canView.ams,
      label: 'Attendance Master',
      keywords: 'attendance master,approve activity,approved,rejected,checkins',
    },
    {
      path: '/employee-activity/:attendanceMasterTabId/create-check-in',
      show: canView.ams,
      label: 'Attendance Create Check In',
      keywords: 'attendance,create check in',
    },
    {
      path: '/shift/:shiftTabId',
      show:
        canView.ams &&
        (canView.ams_shiftManagement_projectShift ||
          canView.ams_shiftManagement_regularShift ||
          canView.ams_shiftManagement_swapShift),
      label: 'Attendance Shift Master',
      keywords: 'regular shift,swap shift,shifts',
    },
    {
      path: '/shift/:shiftTabId/:menuOption',
      show:
        canView.ams &&
        (canView.ams_shiftManagement_projectShift ||
          canView.ams_shiftManagement_regularShift ||
          canView.ams_shiftManagement_swapShift),
      label: 'Attendance Shift Create',
      keywords: 'attendance shift create,shift create,shift history',
    },
    {
      path: '/ncns/:ncnsTabId',
      show: canView.ams,
      label: 'Attendance NCNS Master',
      keywords: 'ncns,ncns confirmed,ncns dismissed',
    },
    {
      path: '/rules-exceptions',
      show: canView.ams,
      label: 'Attendance Rules And Exceptions',
      keywords:
        'attendance rules and exceptions,attendance rules,attendance exceptions,rules and exceptions',
    },
    {
      path: '/settings',
      show: canView.ams,
      label: 'Attendance Settings',
      keywords: 'attendance settings,settings',
    },
    {
      path: '/settings/:tabId',
      show: canView.ams,
      label: 'Attendance Settings',
      keywords: 'attendance settings,settings',
    },
    {
      path: '/settings/add-project',
      show: canView.ams,
      label: 'Attendance Settings Add project',
      keywords: 'add project',
    },
    {
      path: '/settings/edit-project/:projectId',
      show: canView.ams,
      label: 'Attendance Settings Edit Project',
      keywords: 'edit project',
    },
    {
      path: '/reports',
      show: canView.ams,
      label: 'Attendance Reports',
      keywords: 'attendance reports,reports',
    },
    {
      path: '/reports/create-report',
      show: canView.ams,
      label: 'Attendance Create Report',
      keywords: 'attendance create report,create report',
    },
    {
      path: '/reports/edit-report/:reportId',
      show: canView.ams,
      label: 'Attendance Edit Report',
      keywords: 'attendance edit Report,edit report',
    },
    {
      path: '/reports/:reportId',
      show: canView.ams,
      label: '',
      keywords: '',
    },
    {
      path: '/report/:reportId',
      show: canView.ams,
      label: '',
      keywords: '',
    },
    {
      path: '/report/finance/:reportId',
      show: canView.ams,
      label: '',
      keywords: '',
    },
    {
      path: '/individualreport',
      show: canView.ams,
      label: 'Attendance Individual Report',
      keywords:
        'attendance individual report,individual report,attendance report',
    },
    {
      path: '/rules-exceptions/add-rule',
      show: canView.ams,
      label: 'Attendance Add Rule',
      keywords: 'add rule',
    },
    {
      path: '/Shift-Management/shift-details/',
      show: canView.ams,
      label: 'Attendance Shift Management',
      keywords: 'shift management,shift details',
    },
    {
      path: '/settings/shift/shift-details/',
      show: canView.ams,
      label: 'Attendance Shift Management',
      keywords: 'settings, shift management,shift details',
    },
    {
      path: '/rules-exceptions/view-rule/:ruleId',
      show: canView.ams,
      label: 'Attendance Rules Exceptions View Rule',
      keywords: 'view rule',
    },
    {
      path: '/rules-exceptions/edit-rule/:ruleId',
      //
      show: canView.ams,
      label: 'Attendance Rules Exceptions Edit Rule',
      keywords: 'edit rule',
    },
    {
      path: '/d365/d365data',
      show: canView.ams,
      label: 'Projects Tabs',
      keywords: 'ams,projects,all,users,shifts',
    },
    {
      path: '/d365/d365report',
      show: canView.ams,
      label: 'Projects Tabs',
      keywords: 'ams,projects,all,users,shifts',
    },
    {
      path: '/d365/d365report/d365Reports/:reportId',
      show: canView.ams,
      label: 'D365 Report',
      keywords: 'ams,d365, reports',
    },
    {
      path: '/projects',
      show: canView.ams,
      label: 'Projects Tabs',
      keywords: 'ams,projects,all,users,shifts',
    },
    {
      path: '/projects/:tabId',
      show: canView.ams,
      label: 'ESS Attendance Master',
      keywords: 'ams,projects,all,users,shifts',
    },
    {
      path: '/projects/all/add-project',
      show: canView.ams,
      label: 'Projects Tabs',
      keywords: 'ams,projects,all,users,shift',
    },
    {
      path: '/projects/all/edit-project/:projectId',
      show: canView.ams,
      label: 'Projects Tabs',
      keywords: 'ams,projects,all,users,shift',
    },
  ];
  const AMSList = AMS_SUB_ROUTES.filter((r) => {
    const isColonExists = (r.path || '').includes(':');
    return r.show && !isColonExists;
  }).map((eachRoute) => {
    const AMSPath = '/attendance' + eachRoute.path;
    return {
      ...eachRoute,
      path: AMSPath,
      url: AMSPath,
      label: eachRoute.label,
      keywords: eachRoute.keywords,
      onClick: () => onSelect(AMSPath),
    };
  });
  const ESS_AMS_SUB_ROUTES = [
    // candidate email form
    {
      path: '/ess/interviews-trainings/email-creation-form',
      label: 'Create Employee Email',
      keywords: 'IT email',
    },
    {
      path: '/empty',
      exact: true,
      label: 'Empty',
      keywords: 'empty,empty screen',
    },
    {
      path: '/mainSettings/company-information',
      exact: true,
      label: 'Company Information',
      keywords: 'company information,information',
    },

    {
      path: '/attendance/projects/all/add-project',
      exact: true,
      label: 'Projects Tabs',
      keywords: 'ams,projects,all,users,shift',
    },
    {
      path: '/attendance/projects/all/edit-project/:projectId',
      exact: true,
      label: 'Projects Tabs',
      keywords: 'ams,projects,all,users,shift',
    },

    {
      path: '/adminConsole/account-details',
      exact: true,
      label: 'Admin Console Account Details',
      keywords: 'account details,admin details',
    },
    {
      path: '/adminConsole/edit-account-details',
      exact: true,
      label: 'Edit Admin Console Account Details',
      keywords: 'edit admin console,edit account details',
    },
    {
      path: '/adminConsole/plans',
      exact: true,
      label: 'Admin Console Plans',
      keywords: 'admin console plans,plans',
    },
    {
      path: '/adminConsole/Branches',
      exact: true,
      label: 'Admin Console Branch',
      keywords: 'admin console,console branch,admin console branch',
    },
    {
      path: '/adminConsole/branches/add-branch',
      exact: true,
      label: 'Admin Console Add Branch',
      keywords:
        'admin console add branch,add branch for admin console,add branch',
    },
    {
      path: '/adminConsole/branches/edit-branch/:editBranchId',
      exact: true,
      label: 'Admin Console Branches',
      keywords: 'admin console branch,console branch',
    },
    {
      path: '/adminConsole/logs',
      exact: true,
      label: 'Audit logs',
      keywords: 'audit logs,logs',
    },
  ];
  const LMSAMSUrlList = ESS_AMS_SUB_ROUTES.filter((eachRoute) => {
    const isColonExists = (eachRoute.path || '').includes(':');
    return !isColonExists;
  }).map((eachRoute) => {
    return {
      ...eachRoute,
      url: eachRoute.path,
      label: eachRoute.label,
      keywords: eachRoute.keywords,
      onClick: () => onSelect(eachRoute.path),
    };
  });
  const history = useHistory();
  const onSelect = (url) => {
    history.push(url);
  };
  const LMS_SUB_ROUTES = [
    {
      path: '/leave-master',
      show: canView.lms_leaveMaster,
      label: 'Leave Master',
      keywords: 'leave request,request leave',
    },
    {
      path: '/leave-master/leave-requested/apply-leave-on-behalf',
      show: canView.lms_leaveMaster,
      label: 'Apply Leave On Behalf',
      keywords: 'apply leave,leave on behalf',
    },
    {
      path: '/leave-master/leave-requested/delegate-approval',
      show: canView.lms_leaveMaster,
      label: 'Delegate Approval',
      keywords: 'delegate approval,approval,delegate',
    },
    {
      path: '/leave-master/:leaveMasterTabId',
      show: canView.lms_leaveMaster,
      label: 'Leave Master',
      keywords:
        'leave request,upcoming leave,rejected leave,approved leave,upcoming,rejected,approved,leave',
    },
    {
      path: '/HolidayList',
      show: canView.lms_holidaysList,
      label: 'Holiday',
      keywords: 'holiday,add holiday,import holiday,export holiday',
    },
    {
      path: '/ReportList',
      show: canView.lms_reports,
      label: 'Leave Report',
      keywords: 'leave,report',
    },
    {
      path: '/HolidayList/add',
      show: canView.lms_holidaysList,
      label: 'Add Holiday',
      keywords: 'add holiday,holiday',
    },
    {
      path: '/HolidayList/edit/:holidayId',
      show: canView.lms_holidaysList,
    },
    {
      path: '/leavetype',
      show: canView.lms_settings_leaveType,
      label: 'Leave Type',
      keywords: 'leave type,type of leave',
    },
    {
      path: '/leavetype/create-leave-type',
      show: canView.lms_settings_leaveType,
      label: 'Create Leave',
      keywords: 'create leave,leave',
    },
    {
      path: '/leavetype/edit-leave-type/:leaveTypeId',
      show: canView.lms_settings_leaveType,
    },
    {
      path: '/leavebalance',
      show: canView.lms_settings_leaveBalance,
      label: 'Leave Balance',
      keywords: 'leave balance,balance leave',
    },
    {
      path: '/reports/create-report',
      show: canAdd.lms_reports,
      label: 'Create Leave Report',
      keywords: 'leave report,create leave report,create leave,create report',
    },

    {
      path: '/reports/individualreport',
      show: canView.lms_reports,
      label: '',
      keywords: '',
    },
    {
      path: '/reports/loss-of-pay',
      show: canView.lms_reports,
      label: 'Individual Report',
      keywords: 'individual report',
    },
    {
      path: '/reports/late-checkins',
      show: canView.lms_reports,
      label: 'Late checkins',
      keywords: 'late checkins',
    },
    {
      path: '/reports/time-off',
      show: canView.lms_reports,
      label: 'Time Off',
      keywords: 'TIme Off',
    },
    {
      path: '/reports/leave-balance',
      show: canView.lms_reports,
      label: 'Leave Balance',
      keywords: 'leave balance,balance leave',
    },
    {
      path: '/reports/:customReportId',
      show: canView.lms_reports,
      label: 'Custom reports',
      keywords: 'custom report',
    },
    {
      path: '/reports/edit-report/:reportId',
      show: canEdit.lms_reports,
      label: 'Leave Management Edit Report',
      keywords: 'leave management,edit report',
    },
    {
      path: '/leavepolicy/:leaveTypeId',
      show: canView.lms_settings,
      label: 'Leave Policy',
      keywords: 'leave policy,policy',
    },
    {
      path: '/leavetype/viewpolicy/:leaveTypeId/:countryId',
      show: canView.lms_settings_leaveType,
      label: '',
      keywords: '',
    },
    {
      path: '/leavetype/editpolicy/:leaveTypeId',
      show: canEdit.lms_settings_leaveType,
      label: 'Edit Leave Policy',
      keywords: 'edit policy',
    },
  ];
  const LMSUrlList = LMS_SUB_ROUTES.filter((r) => {
    const isColonExists = (r.path || '').includes(':');
    return r.show && !isColonExists;
  }).map((r) => {
    const LMSPath = '/leave-management' + r.path;
    return {
      ...r,
      path: LMSPath,
      url: LMSPath,
      label: r.label,
      keywords: r.keywords,
      onClick: () => onSelect(LMSPath),
    };
  });

  const UMS_SUB_ROUTES = [
    {
      path: '/users',
      show: canView.ums_users,
      redirectTo: '/users/active',
      label: 'List of Active Employees',
      keywords: 'Employee list,All employees,total employee list',
    },
    {
      path: '/users/:usersType/create-employee',
      show: canView.ums_users,
      label: 'Create Employee',
      keywords: 'create employee details,employee account creation,create',
      // redirectTo: '/users/:usersType/create-employee',
    },
    {
      path: '/users/:usersType/initiate-offboarding',
      show: canView.ums_users,
      label: 'Inititate Offboarding',
      keywords:
        'inititate offboarding,offboard employee,relieve candidate,terminate enployee',
      // redirectTo: '/users/:usersType/initiate-offboarding',
    },

    {
      path: '/users/:usersType',
      show: canView.ums_users,
      label: 'Employees List',
      keywords:
        'Active Employees,Archived Employees,Current Employees,Old employees list',
    },
    {
      path: '/Groups',
      show: false, // canView.ums_groups
      label: '',
      keywords: '',
    },
    {
      path: '/UserAccess',
      show: canView.ums_userAccess,
      label: '',
      keywords: '',
    },
    {
      path: '/UserAccess/Create-group',
      show: true,
      label: 'Create Group',
      keywords: 'create group,add new group',
    },
    {
      path: '/UserAccess/edit/:editgroupId',
      show: true,
      label: 'Edit Group',
      keywords: 'edit group,update group',
    },
    {
      path: '/department',
      show: canView.ums_department,
    },
    {
      path: '/department/add',
      show: canView.ums_department,
      label: 'Add Department',
      keywords: 'add Department,add new dept,create new dept',
    },
    {
      path: '/Hierarchy',
      show: canView.ums_hierarchy,
      label: 'Hierarchy',
      keywords: '',
    },
    {
      path: '/asset-management',
      show: canView.ums_assetManagement,
      label: 'Asset Management',
      keywords: 'manage assets',
    },
    {
      path: '/skill-management',
      show: canView.ums_skillManagement,
      label: 'Skill Management',
      keywords: 'manage skills,employee skill manage',
    },
    {
      path: '/reports',
      show: canView.ums_reports,
      label: 'Employee Management Reports',
      keywords: 'EM reports,ums reports,Report list',
    },
    {
      path: '/user-details',
      show: canView.ums_users_userProfile,
      label: 'User Details',
      keywords: 'Employee info,user Info,emp details',
    },
    // {
    {
      path: '/Requests',
      show: canView.ums_requests,
      label: 'Profile Requests',
      keywords: 'my requests,request,change requests',
    },
    {
      path: '/Settings',
      show: canView.ums_settings,
      label: 'Employee Management settings',
      keywords: 'user management settings,manage user,settings',
    },
    {
      path: '/Settings/:branchId',
      show: canView.ums_settings,
      label: 'Employee Management settings',
      keywords: 'user management settings,manage user,settings',
    },
    {
      path: '/reports/CreateReport',
      show: canAdd.ums_reports,
      label: 'Create Employee Management Report',
      keywords: 'create report,New report',
    },
    {
      path: '/edit-report/:reportId',
      show: canEdit.ums_reports,
      label: 'Edit Employee management Report',
      keywords: 'edit report,update report',
    },
    {
      show: canView.ums_users, //todo: have to use proper permissions
      path: '/offboarding',
      label: 'Offboarding Employee Details',
      keywords: 'offboarding,relieving employee,leaving candidate,',
    },
    {
      show: canView.ums_users,
      path: '/offboarding/:tabId',
      label: 'Offboarding',
      keywords:
        'resignations,terminations,end of contracts,relieving/retaining',
    },
    {
      show: canView.ums_users,
      path: '/offboarding/:tabId/schedule-meeting',
      label: 'Schedule Meeting for Offboarding Employee',
      keywords: '',
    },
    {
      show: canView.ums_users,
      path: '/offboarding/:tabId/view-schedule',
      label: 'View Offboarding Schedule',
      keywords: 'offboarding schedule,view schedule',
    },
    {
      show: canView.ums_users,
      path: '/offboarding/:tabId/:hrId',
      label: '',
      keywords: '',
    },

    {
      path: '/report/:reportId',
      show: canView.ums_reports,
      label: 'Employee Management reports',
      keywords: 'head count report,employee list report',
    },
    {
      path: '/DepartmentDetails/:departmentId',
      show: canView.ums_department,
      label: 'Department Details',
      keywords: 'department details,dept info,dept details',
    },
  ];
  const UMSUrlList = UMS_SUB_ROUTES.filter((r) => {
    const isColonExists = (r.path || '').includes(':');
    return r.show && !isColonExists;
  }).map((eachRoute) => {
    const UMSPath = '/user-management' + eachRoute.path;
    return {
      ...eachRoute,
      path: UMSPath,
      url: UMSPath,
      label: eachRoute.label,
      keywords: eachRoute.keywords,
      onClick: () => onSelect(UMSPath),
    };
  });
  const commands = [
    {
      command: '/filter',
      label: 'Filter by given options',
      filterTabs: [],
    },
    {
      command: '/find',
      label: 'Search the page',
      filterTabs: [],
    },
  ];
  return (
    <CommandPalette
      list={[
        ...LMSAMSUrlList,
        ...ESSList,
        ...LMSUrlList,
        ...UMSUrlList,
        ...AMSList,
      ]}
      commands={commands}
      t={t}
    />
  );
}
